export interface SchemaTableTypeData {
  imgLightModeSrc: string;
  imgDarkModeSrc: string;
  title: string;
  description: string;
  docLink: string;
  tableType: FireboltTableType;
}

export enum FireboltTableTypeEnum {
  FACT_TABLE = 'FACT',
  DIMENSION_TABLE = 'DIMENSION',
}

export interface FireboltTableType {
  tableType: FireboltTableTypeEnum;
  displayText: string;
  description: string;
}

// DateTime & Geography types are not handled
export enum BigQueryPartitionStyleEnum {
  NO_PARTITION = 'NO_PARTITION',
  INGESTION_TIME_BASED_PARTITION = 'INGESTION_TIME_BASED_PARTITION',
  FIELD_BASED_PARTITION = 'FIELD_BASED_PARTITION'
}

export enum BigQueryPartitionTypeEnum {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

